import React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import { IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";

const SelectionToolbar = ({ numSelected }) => (
  <Toolbar
    sx={[
      { pl: { sm: 2 }, pr: { xs: 1, sm: 1 } },
      numSelected > 0 && {
        bgcolor: (theme) =>
          alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
      },
    ]}
  >
    {numSelected > 0 ? (
      <Typography sx={{ flex: "1 1 100%" }} color="inherit" variant="subtitle1" component="div">
        {numSelected} seleccionados
      </Typography>
    ) : (
      <Typography sx={{ flex: "1 1 100%" }} variant="h6" id="tableTitle" component="div">
        Usuarios
      </Typography>
    )}
    {numSelected > 0 ? (
      <Tooltip title="Eliminar">
        <IconButton>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    ) : (
      <Tooltip title="Filtros">
        <IconButton>
          <FilterListIcon />
        </IconButton>
      </Tooltip>
    )}
  </Toolbar>
);

SelectionToolbar.propTypes = { numSelected: PropTypes.number.isRequired };
export default SelectionToolbar;
